import { SLAViewDto } from '@issuemanager/api-client';
import { isAfterDate } from '@issuemanager/apps/client/utils';
import { IssueTimelineEventTypeEnum } from '@issuemanager/constants';

export function getSLAMaxDateTime(
  SLAs: SLAViewDto[],
  severity: string | undefined,
  issueCreatedAt?: string,
): Date | undefined {
  if (!severity || SLAs.length === 0) return undefined;

  const selectedSla = SLAs.find((sla) => sla.severity === severity);
  if (!selectedSla) return undefined;

  const baseDate = new Date(issueCreatedAt || Date.now());
  baseDate.setDate(baseDate.getDate() + selectedSla.maxDueDate);
  return baseDate;
}

export function isDateEarlierThanSLA(
  SLAs: SLAViewDto[],
  severity: string | undefined,
  value: Date | undefined,
  issueCreatedAt?: string,
  slaEvent?: { eventType: string } | null,
): boolean {
  if (slaEvent?.eventType === IssueTimelineEventTypeEnum.SLADeactivated) {
    return true;
  }

  if (!severity || !value) return true;

  const selectedSla = SLAs.find((sla) => sla.severity === severity);
  if (!selectedSla) return true;

  const maxDueDate = getSLAMaxDateTime(SLAs, severity, issueCreatedAt);
  if (!maxDueDate) return true;

  return !isAfterDate(value, maxDueDate);
}
